import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { ShippingMethodCode } from '@web/shared/module/shop';

@jsonObject
export class AdminOrderShipmentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;
}
